import React from "react";
import ThemedButton from "../../components/ui/ThemeButton";
import { Service } from "../../types/service";

interface ServiceCardProps {
  index: number;
  service: Service;
  themeColor: string;
  onViewDetails: (service: Service) => void;
}

const ServiceCard: React.FC<ServiceCardProps> = ({
  index,
  service,
  themeColor="#885ABB",
  onViewDetails,
}) => {
  const firstImage = service.gallery?.[0] || "/placeholder.jpg";

  return (
    <section className="relative  px-6 md:px-12 max-w-6xl mx-auto font-serif">
      {/* Background Accent */}
      <div className="absolute inset-0 bg-gradient-to-br from-white via-gray-50 to-gray-100 rounded-3xl shadow-md -z-10"></div>

      {/* Number and Divider */}
      <div className="flex items-center mb-6 mt-8">
        <div
          className="flex items-center justify-center rounded-full h-14 w-14 text-white font-bold text-lg shadow-lg"
          style={{ backgroundColor: themeColor }}
        >
          {index}
        </div>
        <div
          className="h-1 ml-4 flex-grow rounded-full opacity-70"
          style={{ backgroundColor: themeColor }}
        />
      </div>

      {/* Card Content */}
      <div className="flex flex-col md:flex-row items-center gap-10  ">
        {/* Image Section */}
        <div className="w-full md:w-1/3 flex justify-center">
          <img
            src={firstImage}
            alt={service.title}
            className="w-72 h-72 object-cover rounded-2xl shadow-md border border-gray-200"
          />
        </div>

        {/* Text Section */}
        <div className="flex-1 text-center md:text-left">
          <h3 className="text-3xl md:text-4xl font-serif font-semibold text-gray-900 mb-4">
            {service.title}
          </h3>
          <div>
            
          </div>
          <div className="max-w-md">
            <p className="text-gray-700 leading-relaxed text-lg mb-6 font-light max-w-2xl mx-auto md:mx-0 break-words font-serif">
            {service.description}
          </p>
          </div>
         
          <div className="flex justify-center md:justify-start">
            <ThemedButton
              themeColor={themeColor}
              onClick={() => onViewDetails(service)}
               className="px-6 py-2 rounded-md border transition-colors duration-300 hover:bg-white hover:text-black hover:border-gray-300"
            >
              View Details
            </ThemedButton>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceCard;
